// @ts-nocheck

import { request } from '../../../../../context';
import type { ApiOptions } from '../../../../../context';
import type {
    PostReviewIntelligentPartnerDialogFlowBatchCheckByFlowIdParam,
    BaseResponseVoid,
} from '../../../../../types';

/**
 * 对话流程批量校验
 *
 * @export
 * @tags 智能陪练-对话流程(节点, 全局配置, 客户画像)
 * @link [POST] /review/intelligentPartner/dialogFlow/batchCheck/{flowId}
 * @param flowId
 */
export function postReviewIntelligentPartnerDialogFlowBatchCheckByFlowId(
    options: ApiOptions<PostReviewIntelligentPartnerDialogFlowBatchCheckByFlowIdParam, never> & {
        segments: PostReviewIntelligentPartnerDialogFlowBatchCheckByFlowIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, PostReviewIntelligentPartnerDialogFlowBatchCheckByFlowIdParam, never>(
        '/review/intelligentPartner/dialogFlow/batchCheck/{flowId}',
        {
            ...options,
            method: 'post',
            __$requestCalleeName: 'postReviewIntelligentPartnerDialogFlowBatchCheckByFlowId',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-对话流程(节点, 全局配置, 客户画像)'],
        path: '/review/intelligentPartner/dialogFlow/batchCheck/{flowId}',
        method: 'post',
    },
];
